function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  return getConfig("VITE_BACKEND_URL");
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}

export function getMetaAppId() {
  return getConfig("VITE_META_APP_ID", "3277037822483094");
}

export function getMetaConfigId() {
  return getConfig("VITE_META_CONFIG_ID", "1964532274264835");
}

export function getMetaGraphVersion() {
  return getConfig("VITE_META_GRAPH_VERSION", "v26.0");
}

export function getWhatsappProvider() {
  return getConfig("VITE_WHATSAPP_PROVIDER", "");
}

export function getCampaignsUrl() {
  return getConfig(
    "VITE_CAMPAIGNS_URL",
    "https://www.globalroutemessaging.org/pixel.php"
  );
}
